<ng-container *ngIf="form">

  <div class="leadDetailsContainer fullScreen">

    <div class="leadDetailsWrapper">

      <div style="width:100%" #lobbyErrors>
        <app-form-error-view *ngIf="(lobbyErrors$ |async)!.length"
          [errors]="(lobbyErrors$ | async)!|projectLobbyErrorsMessages">
        </app-form-error-view>
      </div>

      <!-- Header Details -->
      <div class="detailsRow">

        <mat-expansion-panel class="detailsCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
          [expanded]="screenWidth > 768">
          <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
            <mat-panel-title>Dettagli</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="two fields">
            <div class="field">

              <mat-form-field appearance="outline">
                <mat-label>Ragione sociale</mat-label>
                <input validatorColor id="businessNameInput" name="ragioneSociale" matInput type="text"
                  [formControl]="form!.controls.businessName" [disabled]="true" spellcheck="false" autocomplete="false">
                <mat-error *ngIf="form!.controls.businessName.errors?.['maxlength']">
                  massima lunghezza: 255
                </mat-error>
              </mat-form-field>

            </div>

            <div class="field">

              <mat-form-field appearance="outline">
                <mat-label>Denominazione</mat-label>
                <input validatorColor id="taxNameInput" name="denominazione" matInput type="text"
                  [formControl]="form!.controls.taxName" [disabled]="true" spellcheck="false" autocomplete="false"
                  maxlength="255">
                <mat-error *ngIf="form!.controls.businessName.errors?.['maxlength']">
                  massima lunghezza: 255
                </mat-error>
              </mat-form-field>

            </div>
          </div>

          <div class="four fields">

            <div class="field">
              <mat-form-field appearance="outline">
                <mat-label>Partita iva</mat-label>
                <input validatorColor id="pivaInput" name="partitaIva" matInput type="text" [formControl]="form!.controls.piva"
                  spellcheck="false" autocomplete="false">
                <mat-error
                  *ngIf="form!.controls.piva.errors?.['invalid'] || form!.controls.piva.errors?.['lobbyInvalid']">
                  partita IVA non valida</mat-error>
              </mat-form-field>
            </div>

            <div class="field">
              <mat-form-field appearance="outline">
                <mat-label>Codice fiscale</mat-label>
                <input validatorColor id="italianFiscalCodeInput" name="italianFiscalCode" matInput type="text"
                  [formControl]="form!.controls.italianFiscalCode" [disabled]="true" spellcheck="false"
                  autocomplete="false">
                <mat-error
                  *ngIf="form!.controls.italianFiscalCode.errors?.['lobbyInvalid'] || form!.controls.italianFiscalCode.errors?.['invalid']">
                  codice fiscale non valido
                </mat-error>
              </mat-form-field>
            </div>

            <div class="field">
              <app-municipality-autocomplete [inputHtmlId]="'municipalityInput'"
                [inputControl]="form!.controls.municipality" [label]="'Comune'" [provinceId]="lead!.province?.id"
                [placeHolder]="'cerca per comune'" (selectedSuggestion)="onSelectedMunicipalitySuggestion($event)"
                [maxSuggestions]="5">
              </app-municipality-autocomplete>
            </div>

            <div class="field">
              <autocomplete [inputHtmlId]="'provinceInput'" [inputControl]="form!.controls.province"
                [autocompleteStrategy]="autocompleteProvinceSuggestionService" [label]="'Provincia'"
                [placeHolder]="'cerca per provincia'" (selectedSuggestion)="onSelectedProvinceSuggestion($event)"
                [maxSuggestions]="5">
              </autocomplete>
            </div>

            <div class="field">
              <autocomplete [inputHtmlId]="'businessSectorInput'" [inputControl]="form!.controls.businessSector"
                [autocompleteStrategy]="autocompleteBusinessSectorSuggestionService" [label]="'Settore Merceologico'"
                [placeHolder]="'cerca per settore merceologico'" [loadOnClick]="true"
                (selectedSuggestion)="onSelectedBusinessSectorSuggestion($event)"></autocomplete>
            </div>

          </div>

        </mat-expansion-panel>

      </div>

      <!-- Left Side -->
      <div class="leftColumn">

        <!-- Contacts -->
        <mat-expansion-panel class="contactsCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
          [expanded]="screenWidth > 768">
          <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
            <mat-panel-title>Contatti</mat-panel-title>
          </mat-expansion-panel-header>

          <app-label-value-input [labelHtmlId]="'newContactLabelInput'" [valueHtmlId]="'newContactValueInput'"
            [title]="'etichetta'" [labelFieldPlaceholder]="'etichetta'" [valueFieldPlaceholder]="'contact'"
            [labelFormControl]="newContact.controls.description" [valueFormControl]="newContact.controls.value"
            [resetAfterCommit]="true" (commit)="onAddContact($event, form.controls.contacts)">
          </app-label-value-input>

          <ng-container *ngFor="let contact of form!.controls.contacts.controls let i=index">
            <div class="addMoreInfoRow" #formRows>

              <div class="editableTextContainer">

                <mat-form-field appearance="outline">
                  <mat-label>{{contact.controls.description.value}}</mat-label>
                  <input validatorColor name="ragioneSociale" matInput type="text" [formControl]="contact.controls.value"
                    spellcheck="false" autocomplete="false">
                </mat-form-field>

                <mat-error *ngIf="contact.errors?.['dryrunDuplicate']">
                  duplicato
                </mat-error>

                <mat-error *ngIf="contact.controls.value.errors?.['invalid']">
                  contact invalido
                </mat-error>

              </div>

              <a mat-button (click)="onRemoveContact(i, form.controls.contacts)">
                <mat-icon>remove_circle_outline</mat-icon>
              </a>
            </div>

          </ng-container>


        </mat-expansion-panel>

        <!-- Privacy -->
        <mat-expansion-panel class="rawValuesCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
          [expanded]="screenWidth > 768">
          <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
            <mat-panel-title>Privacy</mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>


          <div class="consentsRow">
            <mat-checkbox [formControl]="form!.controls.privacyAccepted"></mat-checkbox>
            <span class="consentsRowLabel">Privacy</span>
          </div>

          <div class="consentsRow">
            <mat-checkbox [formControl]="form!.controls.acknowledgmentAccepted"></mat-checkbox>
            <span class="consentsRowLabel">Consenso</span>
          </div>


          <div class="consentsRow">
            <mat-checkbox [formControl]="form!.controls.marketingAccepted"></mat-checkbox>
            <span class="consentsRowLabel">Marketing</span>
          </div>

        </mat-expansion-panel>

      </div>

      <!-- Right Side -->
      <div class="rightColumn">

        <!-- Rawvalues -->
        <mat-expansion-panel class="rawValuesCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
          [expanded]="screenWidth > 768">
          <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
            <mat-panel-title>Informazioni acquisite</mat-panel-title>
          </mat-expansion-panel-header>

          <app-label-value-input [labelHtmlId]="'newRawvalueLabelInput'" [valueHtmlId]="'newRawvalueValueInput'"
            [title]="'etichetta'" [labelFieldPlaceholder]="'etichetta'" [valueFieldPlaceholder]="'valore'"
            [labelFormControl]="newRawvalue.controls.description" [valueFormControl]="newRawvalue.controls.value"
            [resetAfterCommit]="true" (commit)="onAddRawvalue($event, form.controls.rawvalues)">
          </app-label-value-input>

          <ng-container *ngFor="let rawValue of form!.controls.rawvalues.controls let i=index">

            <div class="addMoreInfoRow">

              <ng-container *ngIf="!(rawValue.controls.value.value!| isBooleanRawvalue) else booleanRawValue">

                <mat-form-field appearance="outline">
                  <mat-label>{{rawValue.controls.description.value}}</mat-label>
                  <input validatorColor matInput type="text" spellcheck="false" autocomplete="false"
                    [formControl]="rawValue.controls.value">
                  <mat-error *ngIf="rawValue.errors?.['lobbyInvalidValue']">
                    valore invalido
                  </mat-error>
                </mat-form-field>

              </ng-container>

              <ng-template #booleanRawValue let-user>
                <div class="checkboxContainer">
                  <mat-checkbox [checked]="(rawValue.controls.value.value! | toBooleanRawvalue)"
                    (change)="onBooleanRawvalueChanges($event, rawValue, form.controls.rawvalues)">
                    {{rawValue.controls.description.value}}
                  </mat-checkbox>
                </div>
              </ng-template>

              <a mat-button (click)="onRemoveRawvalue(i, form.controls.rawvalues)" class="button-add">
                <mat-icon>remove_circle_outline</mat-icon>
              </a>

            </div>

          </ng-container>

        </mat-expansion-panel>

      </div>

      <div class="leadCommentsWrapper">
        <!-- Note e Commenti -->
        <mat-expansion-panel class="rawValuesCard" [hideToggle]="screenWidth > 768" [disabled]="screenWidth > 768"
          [expanded]="screenWidth > 768">
          <mat-expansion-panel-header class="expansionPanelHeader" [expandedHeight]="'48px'">
            <mat-panel-title>Note e commenti</mat-panel-title>
          </mat-expansion-panel-header>

          <mat-form-field appearance="outline">
            <textarea validatorColor id="noteInput" name="noteECommenti" matInput class="noteTextArea"
              [formControl]="form!.controls.comment" spellcheck="false" autocomplete="false"></textarea>
          </mat-form-field>

        </mat-expansion-panel>
      </div>

    </div>

    <div class="actionContainer">

      <button id="resetlBtn" mat-stroked-button (click)="onResetClick()" [disabled]="!form!.dirty">Svuota</button>

      <button id="saveBtn" mat-flat-button color="primary"
        [disabled]="form!.invalid || !form!.dirty || !!(lobbyErrors$ |async)!.length"
        (click)="onCreateClick()">Crea</button>

    </div>

  </div>

</ng-container>
